import { TableCell, TableRow } from "flowbite-react";
import type { FC } from "react";
import { useState } from "react";
import type { CommissionLevel } from "../../../types/commission-level";
import { SortableTable } from "../../SortableTable";
import { sortData, updateSortState } from "../../../lib/sorting";
import type { SortState } from "../../../lib/sorting";
import { EditCommissionLevelModal } from "./EditCommissionLevelModal";
import { DeleteCommissionLevelModal } from "./DeleteCommissionLevelModal";

interface CommissionLevelsTableProps {
  levels: CommissionLevel[];
  onUpdate: () => Promise<void>;
}

export const CommissionLevelsTable: FC<CommissionLevelsTableProps> = function ({
  levels,
  onUpdate,
}) {
  const [sortState, setSortState] = useState<SortState<string>>({
    key: "level_number",
    direction: "asc",
  });

  const handleSort = (key: string) => {
    setSortState((current) => updateSortState(current, key));
  };

  const columns = [
    { key: "level_number", label: "Level", sortable: true },
    { key: "description", label: "Beschreibung", sortable: true },
    { key: "actions", label: "Aktionen", sortable: false },
  ];

  const sortedLevels = sortData(
    levels,
    sortState.key as keyof CommissionLevel,
    sortState.direction
  );

  return (
    <SortableTable
      columns={columns}
      sortState={sortState}
      onSort={handleSort}
    >
      {sortedLevels.map((level) => (
        <TableRow
          key={level.id}
          className="hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          <TableCell className="whitespace-nowrap p-4 text-base font-medium text-gray-900 dark:text-white">
            Level {level.level_number}
          </TableCell>
          <TableCell className="p-4 text-base text-gray-900 dark:text-white">
            {level.description}
          </TableCell>
          <TableCell className="space-x-2 whitespace-nowrap p-4">
            <div className="flex items-center gap-x-3">
              <EditCommissionLevelModal level={level} onUpdate={onUpdate} />
              <DeleteCommissionLevelModal level={level} onUpdate={onUpdate} />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </SortableTable>
  );
};
